<template>
  <div style="background: #F0F2F5 !important;
        padding: 16px 16px 0px 16px !important;" class="todoindex" :style="conheight">
        <!-- <span class="todotitle">待办事项</span> -->
    <div class="todomenu">
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="考勤查询" name="todo">
                <iframe :src="src+'/fvue/statement/querySql/queryView/kqjsmx/grkqmx/true'" class="iframe" v-if="isChildUpdate1" style="width:100%;" :style="conheight">
                </iframe>
            </el-tab-pane>
            <el-tab-pane label="打卡查询" name="todoRead">
                <iframe :src="src+'/fvue/statement/querySql/queryView/ygkqjlcx/dkjlcx/true'" class="iframe" v-if="isChildUpdate2" style="width:100%;" :style="conheight">
                </iframe>
            </el-tab-pane>
        </el-tabs>
    </div>
  </div>
</template>


<script>
  export default {
    name: "haiyaCheck",
     components: {
    },
    data() {
      return {
        activeName: 'todo',
         isChildUpdate1:true,
         isChildUpdate2:false,
         conheight: { height: window.innerHeight  + "px"},
         src:window.location.origin 
      };
    },
    methods: {
        handleClick(tab, event) {
            if(tab.name == "todo") {
                this.isChildUpdate1 = true;
                this.isChildUpdate2 = false;
            } else if(tab.name == "todoRead") {
                this.isChildUpdate1 = false;
                this.isChildUpdate2 = true;
            }
        }
    },
    mounted(){
      window.jQuery(".el-container").find(".el-main").css({"height":window.innerHeight+"px","overflow":"hidden"});
    }
  };
</script>
<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
/deep/ .iframe .el-main{
  padding: 0px !important;
}

/deep/ .el-tabs__header{
  margin: 0px !important;
  padding-top: 8px;
}



    /deep/ .todotitle{
        height: 54px;
        line-height: 54px;
        font-size: 14px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #292B44;
    }


    /deep/ iframe{
    border: 0px !important;
  }
</style>
